const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_Pn0V5aB6Q',
      userPoolClientId: '1rgvjpham2bumlhkoa326pv4p1',
      identityPoolId: 'us-east-1:575aa7d6-cb79-4eab-904b-e8c50d0890f9',
    }
  },
  API: {
    REST: {
      'townhome-api': {
        endpoint: 'https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod',
        region: 'us-east-1'
      }
    }
  }
};

export default awsConfig;
